<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keyword" label="关键词">
        <el-input
          v-model.trim="searchModel.keyword"
          placeholder="输入委托单位或项目名称"
          clearable
          @keyup.enter.native="handleQuery(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="handleQuery(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="handleQuery(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <keep-alive>
      <component ref="tableComponent" :is="TableComponent" :key="tableType" :flowState="flowState">
        <div class="type-group">
          <div
            v-for="item in typeList"
            :key="item.value"
            :class="{ 'type-item': true, activated: tableType == item.value }"
            @click="tableType = item.value"
          >
            {{ item.label }}
          </div>
        </div>
      </component>
    </keep-alive>
  </div>
</template>

<script>
import TableInternal from './components/TableInternal';
import TableProcess from '@/views/taskAllocation/components/TableProcess'; // 试验进度

export default {
  components: { TableInternal, TableProcess },
  data() {
    return {
      searchModel: {
        keyword: '',
        dateRange: []
      },
      tableType: 'table0',
      flowState: '0',
      typeList: [
        {
          label: '流程中',
          value: 'table0',
          flowState: '0'
        },
        {
          label: '已完成',
          value: 'table1',
          flowState: '1'
        },
        {
          label: '报告进度',
          value: 'table2'
        }
      ],
      TableComponent: 'TableInternal'
    };
  },
  computed: {},
  watch: {
    tableType(val, oldval) {
      switch (val) {
        case 'table0':
        case 'table1':
          this.flowState = this.typeList.find(item => item.value === this.tableType).flowState;
          this.TableComponent = 'TableInternal';
          break;
        case 'table2':
          this.TableComponent = 'TableProcess';
          break;
      }
    }
  },
  methods: {
    handleQuery() {
      this.$refs.tableComponent.setSearchModel(this.searchModel);
    },
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.$refs.tableComponent.setSearchModel(this.searchModel);
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {} //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
.type-group {
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
  font-size: 0;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;

  .type-item {
    display: inline-block;
    padding: 9px 15px;
    font-size: 12px;
    border-right: 1px solid #dcdfe6;
    border-radius: 0;
    cursor: pointer;

    &:last-of-type {
      border-right: none;
    }
    &.activated {
      color: #ffffff;
      background-color: #009688;
      border-color: #009688;
    }
  }
}
</style>
